import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { KnowledgeGraph } from '@/components/svg/KnowledgeGraph'

export function HeroSection() {
  return (
    <div className="relative min-h-[60vh] flex items-center pt-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div className="max-w-3xl">
            <h1 className="text-6xl font-bold tracking-tight mb-6 animate-in fade-in slide-in-from-bottom-4 duration-1000">
              Master Semantic SEO & Topical Authority
            </h1>
            <p className="text-xl text-muted-foreground mb-8 animate-in fade-in slide-in-from-bottom-6 duration-1000">
              Learn advanced SEO techniques using contextual vectors, semantic content networks, and topical maps to dominate search rankings without relying on backlinks.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 animate-in fade-in slide-in-from-bottom-8 duration-1000">
              <Button
                asChild
                size="lg"
                className="bg-primary hover:bg-primary/90 text-white font-medium shadow-lg hover:shadow-xl transition-all duration-300 scale-100 hover:scale-105"
              >
                <Link to="https://app.withwords.app/signup/">
                  Get Started Free <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </Button>
              <Button variant="outline" size="lg" asChild>
                <Link to="https://app.withwords.app/signin/">Sign In</Link>
              </Button>
            </div>
          </div>

          <div className="hidden lg:block animate-in fade-in slide-in-from-bottom-10 duration-1000">
            <KnowledgeGraph lazyLoad={true} />
          </div>
        </div>
      </div>
    </div>
  )
}
